export default __webpack_public_path__ + "static/media/Home_Material&Comp.8336f4f6.jpg";